<script setup lang="ts">
import type { NuxtError } from '#app'

interface Props {
  error: NuxtError<string>
}

const props = defineProps<Props>()

useHead({
  title: props.error.statusCode.toString(),
})
</script>

<template>
  <div>
    <NuxtLayout>
      <ErrorMessage
        :title="`${error.statusCode}`"
        :description="error.message"
        back-link-label="Return to Home"
        back-link-url="/"
      />
      <DevJson :model-value="error" />
    </NuxtLayout>
  </div>
</template>
